import { ScrollArea as MantineScrollArea, ScrollAreaProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedScrollAreaProps extends ScrollAreaProps {
  gradientScrollbar?: boolean;
  gradientVariant?: GradientVariant;
}

const ScrollArea = forwardRef<HTMLDivElement, ThemedScrollAreaProps>(
  ({ gradientScrollbar = false, gradientVariant = 'primary', styles, children, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];

    if (!gradientScrollbar) {
      return (
        <MantineScrollArea ref={ref} styles={styles} {...rest}>
          {children}
        </MantineScrollArea>
      );
    }

    return (
      <MantineScrollArea
        ref={ref}
        styles={{
          ...styles,
          thumb: {
            backgroundImage: `linear-gradient(180deg, ${gradient.from}, ${gradient.to})`,
            ...(styles as any)?.thumb,
          },
        }}
        {...rest}
      >
        {children}
      </MantineScrollArea>
    );
  }
);

ScrollArea.displayName = 'ScrollArea';

export default ScrollArea;
